import { createAuth } from '@spotify-internal/oauth-silent-authentication';
import { getSpotifyClientId } from '@mrkt/features/env';
import { TokenProviderResult } from './types';

const silentAuth = createAuth({
  clientId: getSpotifyClientId(),
  scopes: [],
});

export const supportsDomainGrant =
  typeof window === 'object' &&
  window.location.protocol === 'https:' &&
  /\.spotify\.(net|com)$/.test(window.location.hostname);

export async function getDomainGrantToken(): Promise<TokenProviderResult> {
  try {
    const [token, expiresIn] = await silentAuth.tokenProvider();
    return [token, expiresIn];
  } catch (error) {
    // logged out
    // requires a page refresh after login
    if (error.error === 'login_required') {
      return [undefined, Infinity];
    }

    // rethrow unexpected errors
    throw error;
  }
}
